// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iY","advertCardNum":"c-a_iZ"};